import Context from "../../../context/Context";



export function getReviewerData(username, tableData) {
  return new Promise((resolve, reject) => {
    const lib = Context.instance.lib
    const portal = Context.instance.getPortal()
    const portalUrl = portal.url
    const url = portalUrl + "/sharing/rest/community/users/" + username
    const token = getToken()
    const options = {
      query: {f: "json"},
      method: "get",
      responseType: "json",
      token: token
    }
    lib.esri.esriRequest(url, options).then(result => {
      const userData = {data: result.data, tableData: tableData}
      resolve(userData)
    }).catch(e => {
      console.error(e, "Couldn't find user ", username)
      resolve()
    })
  })
}

export function getPortalUsers(options) {
  return new Promise((resolve, reject) => {
    const { start, text } = options;
    const lib = Context.instance.lib
    const portal = Context.instance.getPortal()
    const portalUrl = portal.url
    const url = `${portalUrl}/sharing/rest/portals/self/users/search`;

    const token = getToken();
    const query = typeof text === "string" && text.trim().length > 0 
      ? `(${encodeURIComponent(text)})` 
      : "";
    const params = {
      start: start,
      num: 30,
      f: "json",
      q: query,
      sortField: "fullname"
    };

    const reqOptions = {
      query: params,
      method: "get",
      responseType: "json",
      token: token
    }
    lib.esri.esriRequest(url, reqOptions).then(result => {
      resolve(result);
    }).catch(e => {
      console.error("Couldn't query users", e)
      resolve()
    })
  })
}

export function getAllPortalUsers() {
  return new Promise((resolve, reject) => {
    const users = []
    let start = 0
    const processNextBatch = () => {
      if (start === -1) {
        resolve(users)
        return
      }
      getPortalUsers(start).then(result => {
        if (result && result.data && result.data.nextStart && result.data.users) {
          start = result.data.nextStart
          result.data.users.forEach(user => {
            users.push(user)
          })
        } else {
          console.error("Problem getting users")
          reject()
          return
        }
      }).catch(e => {
        console.error("Problem getting users", e)
        reject(e)
      }).finally(() => {
        processNextBatch()
      })
    }
    processNextBatch()
  })
}

function getToken() {
  const esriId = Context.instance.lib.esri.esriId;
  const credential = esriId.findCredential(Context.instance.getPortalUrl());
  return credential && credential.token;
}